'use client';

import { TypeButtonLinkComponentSkeleton } from '@shared/features/contentful/_generated';
import { resolveContentfulTargetProps } from '@shared/features/contentful/linkMap';
import {
    LightRetouchButton,
    LightRetouchButtonSize,
    LightRetouchButtonVariant,
} from '@shared/light-retouch';
import { redirectThroughLandingPageJoin } from '@lp/features/landingPageHandoff/redirectThroughLandingPageJoin';
import { Entry } from 'contentful';
import styles from './HeaderLink.module.scss';

interface HeaderLinkFallbackProps {
    linkItem: Entry<TypeButtonLinkComponentSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', string>;
    variant?: LightRetouchButtonVariant;
}

export default function HeaderLinkFallback({
    linkItem,
    variant = LightRetouchButtonVariant.Primary,
}: HeaderLinkFallbackProps) {
    const { link = '#', target, title, type } = linkItem.fields;
    const isButton = type === true;

    if (isButton) {
        return (
            <LightRetouchButton
                onClick={() => {
                    redirectThroughLandingPageJoin({
                        openInNewTab: target === '_blank',
                    });
                }}
                variant={variant}
                size={LightRetouchButtonSize.Compact}
                className={styles.link}
            >
                {title}
            </LightRetouchButton>
        );
    }

    return (
        <LightRetouchButton
            href={link}
            {...resolveContentfulTargetProps(target)}
            variant={variant}
            size={LightRetouchButtonSize.Compact}
            className={styles.link}
        >
            {title}
        </LightRetouchButton>
    );
}
